import { FormGroup, Label } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import RequiredStarLabel from '../../common/requiredStarLabel';
import FormGroupNote from '../FormGroupNote';
import EntitySelect from '../../entitySelect/EntitySelect';
import { dataContractApi } from '../../../helpers/api/dataContractApi';
import { SwitchboardProductTypeText } from '../../../helpers/enums/switchboardProductTypeEnum';

export default function SwitchboardProductTypeSelect({
  isRequired = false,
  isDisabled
}) {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors }
  } = useFormContext();
  return (
    <FormGroup>
      <Label htmlFor="switchboardProductType">
        {t('Switchboard Product Type')} {isRequired && <RequiredStarLabel />}
      </Label>
      <Controller
        name="switchboardProductType"
        control={control}
        render={({ field }) => (
          <EntitySelect
            name="switchboardProductType"
            displayName={t('Switchboard Product Type')}
            fieldValue={field.value}
            onChange={field.onChange}
            placeholder="Not specified"
            fetchDataFunction={() => {
              return dataContractApi.getDataContractsByContractType(
                'switchboard-product-types'
              );
            }}
            isFetchDataEnum
            enumToText={SwitchboardProductTypeText}
            isDisabled={isDisabled}
          />
        )}
      />
      {errors.switchboardProductType && (
        <FormGroupNote type={'warning'}>
          {errors.switchboardProductType.message}
        </FormGroupNote>
      )}
    </FormGroup>
  );
}
